import type { BlockComponentProps } from "./shared"

export function PullQuoteBlock({ content, resolved }: BlockComponentProps) {
  const pq = (content?.quote as string) ?? ""
  const pqAttr = (content?.attribution as string) ?? ""
  if (!pq) return null
  const pqSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass} max-w-2xl mx-auto`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8 max-w-2xl mx-auto"
  return (
    <section className={pqSectionClass} style={resolved.sectionStyle}>
      <blockquote className="text-2xl font-serif italic text-center" style={{ color: "var(--nos-color-primary, #3b82f6)" }}>
        &quot;{pq}&quot;
        {pqAttr && <footer className="mt-4 not-italic text-base">— {pqAttr}</footer>}
      </blockquote>
    </section>
  )
}
